export function SignedOutPage({
  title,
  description,
  action
}: {
  title: string;
  description: string;
  action?: React.ReactNode;
}) {
  return (
    <main className="centered-page">
      <section className="card card--signed-out">
        <span className="brand-badge">
          <span className="brand-badge__crown" aria-hidden="true">♛</span>
          <span className="brand-badge__text">
            <span className="brand-badge__label">Contribution Blocks</span>
            <span className="brand-badge__sub">Queen One</span>
          </span>
        </span>
        <h1>{title}</h1>
        <p>{description}</p>
        {action !== undefined && <div className="signed-out__actions">{action}</div>}
      </section>
    </main>
  );
}
